import { AxiosRequestConfig } from 'axios'
import config from 'const/config'
import {
  ResetPasswordEligibilityCheckResponse,
  UpdatePasswordResponse
} from 'services/resetPassword/typings'
import apiRequestor from 'services/apiRequestor'
import {
  EligibilityCheckRequest,
  PostLoginUpdatePasswordRequest,
  UpdatePasswordRequest
} from 'typings/resetPassword'
import apiEndpoints from 'const/endPoint'
import {
  getHeaderParams,
  getPostLoginUpdatePasswordParams,
  getUpdatePasswordParams
} from 'helpers/requestParams'
import { readBlackBox } from 'helpers/windowUtility'
import { ResetPasswordEligibilityCheckParams } from 'typings/apiRequest'
import { getCodeChallenge } from 'services/codeVerifier'

const { APIGEE_CLIENT_ID } = config
const authState = 'V1o3Wnk1ZEN5TkR6cWZ5NG8xWmZEanFhUm1vQW9XZG'
const redirectSynchronyCredit = 'https://redirect.synchronycredit.com'
const codeChallenge = getCodeChallenge()
const codeChallengeMethod = 'S256'

const resetPasswordAPI = {
  getEligibilityCheck: async (
    payload: EligibilityCheckRequest
  ): Promise<ResetPasswordEligibilityCheckResponse> => {
    const data: ResetPasswordEligibilityCheckParams = {
      authInfo: {
        appId: APIGEE_CLIENT_ID,
        redirectUri: redirectSynchronyCredit,
        scope: 'reset-password',
        state: authState,
        codeChallenge,
        codeChallengeMethod
      },
      iovation: readBlackBox(),
      userInfo: {
        fullAccountNumber: payload.accountNumber,
        userId: payload.userId
      }
    }

    const requestConfig: AxiosRequestConfig = {
      url: `${apiEndpoints.resetPasswordEligibilityCheck}?client_id=${APIGEE_CLIENT_ID}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data
    }

    const response = await apiRequestor<ResetPasswordEligibilityCheckResponse>({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  },
  getUpdatePassword: async (
    payload: UpdatePasswordRequest
  ): Promise<UpdatePasswordResponse> => {
    const { accessToken } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: `${apiEndpoints.resetPasswordUpdate}?client_id=${APIGEE_CLIENT_ID}`,
      method: 'POST',
      headers: { ...headerParams },
      data: getUpdatePasswordParams(payload)
    }

    const response = await apiRequestor<UpdatePasswordResponse>({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  },
  getPostLoginUpdatePassword: async (
    payload: PostLoginUpdatePasswordRequest
  ): Promise<unknown> => {
    const { accessToken } = payload

    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: `${apiEndpoints.postLoginResetPasswordUpdate}?client_id=${APIGEE_CLIENT_ID}`,
      method: 'PUT',
      headers: { ...headerParams },
      data: getPostLoginUpdatePasswordParams(payload)
    }

    const response = await apiRequestor<unknown>({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  }
}

export default resetPasswordAPI
